module.exports = __webpack_public_path__ + "img/headlights-back.2729ac5b.png";